<template>
    <el-dialog
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        class="custom_form_dialog custom-form-dialog"
        title="转单"
        width="520px"
    >
        <div v-loading="loading" class="custom_form_body">
            <el-form
                ref="workOrderTransferForm"
                :model="workOrderTransferForm"
                :rules="workOrderTransferFormRules"
                label-position="top"
                size="small"
            >
                <el-form-item label="将工单转移给" prop="new_processing_uid">
                    <el-select placeholder="请选择" filterable v-model="workOrderTransferForm.new_processing_uid">
                        <el-option
                            :key="user.id"
                            :label="user.name"
                            :value="user.id"
                            v-for="user in processingUserList"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer">
            <el-button @click="handleDialogClose">取消</el-button>
            <el-button type="primary" @click="handleDialogConfirm">确认</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { mapState } from "vuex";
import { roleDetail, transferProcessing } from "@/api";
import userDepartmentSelection from "./component/userSelection.vue";
export default {
    name: "WorkOrderTransfer",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        workorder_id: {
            type: Number,
            default: 0,
        },
        // 已经选择过的实施人员
        processing_users_selected: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        userDepartmentSelection,
    },
    data() {
        return {
            loading: false,
            workOrderTransferForm: {
                new_processing_uid: "",
            },
            workOrderTransferFormRules: {},

            processingUserList: [], // 可以选择的
            processingUserSelectedList: [], // 已经选择过的
        };
    },
    computed: {
        ...mapState(["userInfo"]),
        owner_uid() {
            return this.userInfo && this.userInfo.user && this.userInfo.user.id;
        },
    },
    created() {
        this.processingUserSelectedList = this.processing_users_selected.map((item) => {
            return item.processing_user;
        });
        this.$nextTick(()=> {
            this.getRoleDetail()
        })
    },
    methods: {
        // 关闭弹窗
        handleDialogClose() {
            this.$emit("update:dialogVisible", false);
        },
        // 获取后台已经配置的角色人员
        getRoleDetail() {
            roleDetail({
                role_type: "processing_user"
            }).then(res=> {
                if(res.code === 200) {
                    const data = res.data || []
                    const selectedUids = this.processingUserSelectedList.map((item) => item.id);
                    // 从实施角色中的全部未被选择人员中选择，排除掉当前工单已经选择过的
                    const processingUserList = data.filter((item) => !selectedUids.includes(item.id));
                    this.processingUserList = processingUserList;
                }
            })
        },
        // 确定
        handleDialogConfirm() {
            this.$refs.workOrderTransferForm.validate((valid) => {
                if (valid) {
                    if (!this.workOrderTransferForm.new_processing_uid) return;
                    const params = {
                        workorder_id: this.workorder_id,
                        old_processing_uid: this.owner_uid,
                        new_processing_uid: this.workOrderTransferForm.new_processing_uid,
                    };
                    transferProcessing(params).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.$emit("update:dialogVisible", false);
                            this.$emit("refreshList");
                        }
                    });
                }
            });
        },
    },
};
</script>
